import { Link } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { ClipboardList, KeyRound, ArrowRight } from "lucide-react";

const options = [
  { to: "/admin/results", label: "Manage Result", desc: "Add, edit & delete daily FR/SR results", icon: ClipboardList, testid: "admin-card-results" },
  { to: "/admin/change-password", label: "Change Password", desc: "Update your admin password securely", icon: KeyRound, testid: "admin-card-password" },
];

export default function AdminDashboard() {
  return (
    <AdminLayout title="Dashboard" testid="admin-dashboard">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {options.map((o) => {
          const Icon = o.icon;
          return (
            <Link
              key={o.to}
              to={o.to}
              data-testid={o.testid}
              className="group flex items-start justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <div className="flex items-start gap-3">
                <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-red-50 text-red-600 shrink-0">
                  <Icon size={22} />
                </span>
                <div>
                  <p className="font-oswald text-lg font-bold text-slate-900">{o.label}</p>
                  <p className="text-sm text-slate-500 mt-0.5">{o.desc}</p>
                </div>
              </div>
              <ArrowRight className="text-slate-300 group-hover:text-red-600 transition-colors mt-1" size={20} />
            </Link>
          );
        })}
      </div>
    </AdminLayout>
  );
}
